export default __webpack_public_path__ + "static/media/unsplash_image 1.ef3d8fbd.png";